export enum TipoManualEnum {
    Produto = '1',
    Lote = '2',
    Sistema = '3',
    Funcionalidade = '4',
    Usuario = '5'
}